import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { User } from '../../../_models/user';

import { Translation } from '../../../_languages/translations';
import { FormValidator } from '../../../_helpers/form.validator';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.sass']
})

export class UserLoginComponent implements OnInit {

  tr: {};
  formValidator: FormValidator;
  loginForm: FormGroup;
  loading = false;
  error = '';
  // demoId: bigint;
  // demoName: string;
  // demoRole: string;
  // demoEnviroment: string;
  // users: User[];

  @Input() currentUser: User;
  @Output() userLogin = new EventEmitter<{
      email: string,
      password: string
    }>();

  constructor(
    private formBuilder: FormBuilder,
    public trans: Translation
  ) {
    this.formValidator = new FormValidator();
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  ngOnInit() {

    this.tr = this.trans.vocabulary;

    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  changeDemoValue(e: Event) {
    console.log('Pulsado botón para el cambio de variable demoValue. Evento => ');
    console.log(e);

  } // End function changeDemoValue

  // NOTA: función que coge los parámetros del formulario y los "emite" fuera.
  onSubmit(): void {
    console.log('-->--> Pulsado botón LOGIN.');

    if (this.f.email.value === '') {
      this.formValidator.formErrorMessages['email'] = 'Introduzca un valor para el campo.';
    }

    if (this.f.password.value === '') {
      this.formValidator.formErrorMessages['password'] = 'Introduzca un valor para el campo.';
    }

    // Paramos el proceso si los datos del formulario son inválidos.
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;

    this.userLogin.emit({
      email: this.f.email.value,
      password: this.f.password.value
    });
  } // End function onSubmit

} // End class UserLoginComponent
